module.exports = __webpack_public_path__ + "static/media/libby5.0e5a5d07.png";